import { useEffect } from 'react';
import { motion, useSpring } from 'framer-motion';

export default function ScrollProgress() {
  const smoothProgress = useSpring(0, { stiffness: 100, damping: 30 });

  useEffect(() => {
    function handleScroll() {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const current = window.scrollY / totalHeight;
      smoothProgress.set(current);
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [smoothProgress]);

  return (
    <>
      {/* Track background */}
      <div className="fixed top-0 left-0 right-0 h-[3px] z-[100] bg-white/[0.03]" />

      {/* Gradient progress bar */}
      <motion.div
        className="fixed top-0 left-0 h-[3px] z-[100] origin-left"
        style={{
          scaleX: smoothProgress,
          background: 'linear-gradient(90deg, #A84397, #D23CB3, #e94fd4, #D23CB3)',
          backgroundSize: '200% 100%',
        }}
      >
        {/* Glow effect behind the bar */}
        <div
          className="absolute inset-0 blur-[6px] opacity-80"
          style={{ background: 'linear-gradient(90deg, #A84397, #D23CB3, #e94fd4)' }}
        />

        {/* Bright tip at the leading edge */}
        <motion.div
          className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(233,79,212,0.9), rgba(210,60,179,0.4), transparent)',
            boxShadow: '0 0 12px rgba(210,60,179,0.8), 0 0 24px rgba(168,67,151,0.4)',
          }}
          animate={{
            scale: [1, 1.4, 1],
            opacity: [0.8, 1, 0.8],
          }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        />
      </motion.div>

      {/* Animated background shimmer on the bar */}
      <motion.div
        className="fixed top-0 left-0 h-[3px] z-[100] origin-left pointer-events-none"
        style={{
          scaleX: smoothProgress,
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
          backgroundSize: '200% 100%',
        }}
        animate={{ backgroundPosition: ['0% 0%', '200% 0%'] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
      />
    </>
  );
}
